const mapItem = <Value extends Dictionaries.TSelectOption['value'], Data extends Dictionaries.TSelectOption['data']>({
  value,
  name,
  meta,
}: Dictionaries.DictionaryItem) =>
  ({
    value,
    label: name,
    data: { alias: value, ...(meta ? { meta } : {}) },
  }) as unknown as Dictionaries.TSelectOption<Value, Data>;

const isItemValid = (item: Dictionaries.DictionaryItem | undefined) => !!item?.name && !!item?.value;

export const mapLocalDictionary = <
  Value extends Dictionaries.TSelectOption['value'],
  Data extends Dictionaries.TSelectOption['data'] = Dictionaries.TSelectOption['data'],
>(
  items?: ArrayOrReadonlyArray<Dictionaries.DictionaryItem>,
): Array<Dictionaries.TSelectOption<Value, Data>> =>
  items?.filter(isItemValid)?.map((item) => mapItem<Value, Data>(item)) ?? [];
